/* eslint-disable max-len */
import { api, IApiOptions } from '../../utils/api/actions';
import { Constants } from './constants';

export const setTrends = (sport: string, site: string, token: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = `/api/playercompare/sport/${sport}/trending`;

  options = {
    ...options,
    route,
    params: {
      sport,
      token,
      site
    },
  };

  return api(
    Constants.SET_TRENDS, {
    ...options,
  },
  );
};